import React from 'react'
import LoadingMessage from './LoadingMessage'

/**
 * @typedef {Object} PageLoadingProps
 * @property {string} [message]
 * @property {string} [minHeightClassName]
 * @property {string} [testId]
 */

/**
 * ページ全体のローディング表示。 各画面の初期表示ローディングで繰り返し使われる page-container > page-content > centered-container のフレームに 共通の
 * {@link LoadingMessage} を配置したもの。
 *
 * @param {PageLoadingProps} props
 * @returns {JSX.Element}
 */
const PageLoading = ({ message = '読み込み中...', minHeightClassName = 'min-h-[360px]', testId = 'pageLoading' }) => {
  return (
    <main className="page-container">
      <section className="page-content">
        <div className="centered-container">
          <LoadingMessage message={message} minHeightClassName={minHeightClassName} testId={testId} />
        </div>
      </section>
    </main>
  )
}

export default PageLoading
